export interface Article {
  id: string;
  story_snapshot?: { icon?: string; value: string; label: string }[];
  why_this_matters?: string;
  context?: { family: string; asset?: string | null; subtype?: string | null; assets_detected?: string[]; confidence?: number };
  slug: string;
  title: string;
  subheadline?: string | null;
  summary?: string;
  summary_ai?: string | null;
  key_takeaways?: string[];
  faqs?: { q: string; a: string }[];
  hero_image_url?: string | null;
  live_state?: string | null;
  live_updates?: { id: string; at: string; label?: string | null; body: string }[];
  lead_visual?: { tier: string; url: string } | null;
  display_dek?: string | null;
  research_label?: string;
  source_name?: string;
  source_article_url?: string | null;
  author_name?: string | null;
  categories?: string[];
  tags?: string[];
  entities?: string[];
  agencies?: string[];
  countries?: string[];
  content_type?: string;
  access_level?: string;
  status?: string;
  is_featured?: boolean;
  is_breaking?: boolean;
  audio_url?: string;
  audio_sponsor?: { advertiser?: string; target_url?: string; sponsor_line?: string; ad_id?: string };
  breaking_at?: string | null;
  import_confidence_score?: number | null;
  kicker?: string | null;
  read_minutes?: number | null;
  word_count?: number | null;
  body_html?: string | null;
  body_teaser?: string | null;
  locked?: boolean;
  views?: number;
  published_at?: string;
  created_at?: string;
}

export interface Regulation {
  id: string;
  slug: string;
  title: string;
  summary: string;
  why_it_matters?: string | null;
  countries: string[];
  agencies: string[];
  topics: string[];
  status: string;
  impact_level: string;
  effective_date?: string | null;
  timeline: { date: string; event: string }[];
  published_at?: string;
}

export interface User {
  id: string;
  email: string;
  full_name: string;
  role: string;
  author_status?: string | null;
  followed_authors?: string[];
  force_password_change?: boolean;
  can_create_seats?: boolean;
  is_premium?: boolean;
  premium_plan?: string | null;
  premium_until?: string | null;
  saved_articles?: string[];
  followed_categories?: string[];
  followed_tags?: string[];
  followed_entities?: string[];
  newsletter_preferences?: Record<string, boolean>;
  notification_preferences?: Record<string, boolean>;
}

export interface Source {
  id: string;
  name: string;
  source_type: string;
  base_url: string;
  polling_frequency_minutes: number;
  publish_mode: string;
  confidence_threshold: number;
  ai_enrich?: boolean;
  trust_level?: string;
  default_category?: string | null;
  active: boolean;
  last_run_at?: string | null;
  last_run_status?: string | null;
  auth_config?: Record<string, any>;
}

export interface IngestionRun {
  id: string;
  source_name: string;
  triggered_by: string;
  started_at: string;
  finished_at?: string | null;
  status: string;
  fetched_count: number;
  created_count: number;
  duplicate_count: number;
  failed_count: number;
  review_count: number;
  logs: string[];
}

export const CATEGORY_ROUTES: { slug: string; name: string; path: string }[] = [
  { slug: "web3", name: "Web3", path: "/web3" },
  { slug: "defi", name: "DeFi", path: "/defi" },
  { slug: "blockchain", name: "Blockchain", path: "/blockchain" },
  { slug: "crypto", name: "Crypto", path: "/crypto" },
  { slug: "government-policy", name: "Policy", path: "/policy" },
  { slug: "markets", name: "Markets", path: "/markets" },
  { slug: "explainers", name: "Explainers", path: "/explainers" },
  { slug: "research", name: "Research", path: "/research" },
  { slug: "ai", name: "Artificial Intelligence", path: "/ai" },
  { slug: "quantum", name: "Quantum", path: "/quantum" },
];
